import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.687 8.353A3.333 3.333 0 0 1 10.021 5h15.15c.952 0 1.859.407 2.491 1.119l4.83 5.434c.543.61.843 1.398.843 2.214v17.9A3.333 3.333 0 0 1 30 35H10.156a3.333 3.333 0 0 1-3.333-3.314L6.687 8.353Z",
      fill: "#AAA"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.39 15.888a.833.833 0 0 1 .832-.888h11.61a.833.833 0 1 1 0 1.667h-11.61a.833.833 0 0 1-.832-.78ZM13.39 20.888a.833.833 0 0 1 .832-.888h11.61a.833.833 0 1 1 0 1.667h-11.61a.833.833 0 0 1-.832-.78ZM13.367 25.867A.833.833 0 0 1 14.2 25h6.632a.833.833 0 1 1 0 1.667H14.2a.833.833 0 0 1-.833-.8Z",
      fill: "#fff"
    }, null, -1)
  ])))
}
export default { render };